import type { AxiosResponse } from 'axios';
import type { ThunkAction } from 'redux-thunk';

import ApiClient, { createTokenConfig } from 'api/ApiClient';
import store from 'store';
import { NotificationsAction, showError } from '@spike/notifications-action';
import type { TransactionsReportAction } from './TransactionsReportActionsType';
import {
    TRANSACTIONS_REPORT_GET_ERROR,
    TRANSACTIONS_REPORT_GET_START,
    TRANSACTIONS_REPORT_GET_SUCCESS
} from './TransactionsReportActionsType';

import type { TransactionsReportDto } from './TransactionsReportDto';
import { convertToTransactionsReport } from './transactionsReportConverter';

// Si ya tienes helper común, usa el tuyo:
const isCancelled = (err: any) => err?.__CANCEL__ === true || err?.code === 'ERR_CANCELED';

const getStart = (): TransactionsReportAction => ({ type: TRANSACTIONS_REPORT_GET_START });

const getSuccess = (report: any): TransactionsReportAction => ({
    type: TRANSACTIONS_REPORT_GET_SUCCESS,
    payload: { report }
});

const getError = (): TransactionsReportAction => ({ type: TRANSACTIONS_REPORT_GET_ERROR });

export const getTransactionsReport = (
    start?: string,
    end?: string,
    page?: number,
    perPage?: number
): ThunkAction<void, any, any, TransactionsReportAction | NotificationsAction> => {
    return async dispatch => {
        dispatch(getStart());

        const state = store.getState();
        const { marketplaceId, token, timeZone } = state.login.auth;

        let url = `/transactions_report?marketplace_id=${marketplaceId}`;
        if (start) url += `&start=${start}`;
        if (end) url += `&end=${end}`;
        if (page) url += `&page=${page}`;
        if (perPage) url += `&per_page=${perPage}`;

        try {
            const response: AxiosResponse<TransactionsReportDto> = await ApiClient.get(url, createTokenConfig(token!));
            dispatch(getSuccess(convertToTransactionsReport(response.data, timeZone!)));
        } catch (apiError) {
            if (!isCancelled(apiError)) {
                dispatch(getError());
                dispatch(showError('Could not load Transactions report.'));
            }
        }
    };
};

export const fetchTransactionsReportForExport = async (start?: string, end?: string) => {
    const { marketplaceId, token, timeZone } = store.getState().login.auth;

    let url = `/transactions_report?marketplace_id=${marketplaceId}&export=true`;
    if (start) url += `&start=${start}`;
    if (end) url += `&end=${end}`;

    const response: AxiosResponse<TransactionsReportDto> = await ApiClient.get(url, createTokenConfig(token!));
    return convertToTransactionsReport(response.data, timeZone!);
};
